import { useState, useEffect, useCallback } from "react";
import { getProducts } from "../api/woocommerce";

export function useProducts(initialFilters = {}) {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [totalPages, setTotalPages] = useState(1);
    const [total, setTotal] = useState(0);
    const [filters, setFilters] = useState({
        page: 1,
        perPage: 12,
        orderby: "date",
        order: "desc",
        search: "",
        category: "",
        minPrice: "",
        maxPrice: "",
        inStock: false,
        ...initialFilters,
    });

    const fetchProducts = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await getProducts(filters);
            setProducts(res.products);
            setTotalPages(res.totalPages);
            setTotal(res.total);
        } catch (err) {
            setError("Failed to load products.");
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, [filters]);

    useEffect(() => {
        fetchProducts();
    }, [fetchProducts]);

    const updateFilters = (newFilters) => {
        setFilters((prev) => ({ ...prev, ...newFilters, page: 1 }));
    };

    const setPage = (page) => {
        setFilters((prev) => ({ ...prev, page }));
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return {
        products,
        loading,
        error,
        totalPages,
        total,
        filters,
        updateFilters,
        setPage,
    };
}
